exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loop-switch{display:inline-block;width:24px;height:24px;line-height:20px;text-align:center;vertical-align:middle;cursor:default;font-size:18px}.loop-switch.disabled{opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ee9b077","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/LoopSwitch.vue
// module id = 3514
// module chunks = 1